import { JsonRpc } from 'eosjs'

import { GAME_ACC } from '../../app/constants'

export function RequestProfile(user) {
  const rpc = new JsonRpc('https://wax-testnet.eosphere.io')
  return rpc?.get_table_rows({
    json: true,
    code: GAME_ACC,
    scope: GAME_ACC,
    lower_bound: user,
    upper_bound: user,
    table: 'userprofiles',
    limit: 1,
  })
}
